import React from 'react';
import { Grid, Typography } from '@mui/material';
import { IReportSectionProps } from 'app/models/Orders/OrderDetails';
import { useStyles } from './OrderDetailsReportStyles';
import { useTranslation } from 'react-i18next';

type OrderInfoProps = {
  orderInfoDetails: IReportSectionProps;
};
export const OrderDetailsReportOrderInfo = (props: OrderInfoProps) => {
  const { classes } = useStyles();
  const orderInfoDetails = props.orderInfoDetails;
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.skillset')}:</Typography>
        </Grid>
        <Grid xs={6} md={10} className={`${classes.dataCell}`}>
          {orderInfoDetails.orderskillset}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.shift')}:</Typography>
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeDataCell}`}>
          {orderInfoDetails.orderShifts}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.noofweeks')}:</Typography>
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeDataCell} `}>
          {orderInfoDetails.numberOfWeeks}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.noofrefs')}:</Typography>
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeDataCell}`}>
          {orderInfoDetails.numberOfRequiredReferences}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.positions')}:</Typography>
        </Grid>
        <Grid xs={6} md={2} className={`${classes.dataCell}`}>
          {orderInfoDetails.numberOfPositions}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.yearsexp')}:</Typography>
        </Grid>
        <Grid xs={6} md={2} className={`${classes.dataCell}`}>
          {orderInfoDetails.yearsOfExperience}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.maxfilessent')}:</Typography>
        </Grid>
        <Grid xs={6} md={2} className={`${classes.dataCell}`}>
          {orderInfoDetails.maxFilesSent}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.fileswfcrfo')}:</Typography>
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeDataCell}`}>
          {orderInfoDetails.numberOfFilesWFCRFO}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell} `}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.filespending')}:</Typography>
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeDataCell}`}>
          {orderInfoDetails.numberOfFilesPending}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.orderinfoSection.verifieddate')}:</Typography>
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeDataCell}`}>
          {orderInfoDetails.verifiedDate}
        </Grid>
      </Grid>
    </Grid>
  );
};
